import { Controller } from "stimulus";
import { EventCheckUserLogin } from "../../events";
import Cookies from "js-cookie";
import { followCategory, unfollowCategory } from "../following_categories/shared_functions";
import { unconditionalTrackEvent } from "../../analytics";
import { SELECT_FOLLOW_CATEGORY_CTA_EVENT } from "../../mixpanel_config";

export default class extends Controller {

  static values = {
    refresh: Boolean
  }
  connect() {
    window.addEventListener(EventCheckUserLogin, e => {
      this.loggedIn = e.detail.userLoggedIn;

      // Populate dropdown with portfolios.
      if (this.loggedIn) {
        fetch(`/${I18n.locale}/following_categories/all_categories`)
          .then(async response => {
              if (!response.ok) {
                throw new Error(`Could not retrieve following categories. Error ${response.status}.`);
              }

              const data = await response.json();
              if (!data) {
                throw new Error(`Could not retrieve following categories. Invalid data returned.`);
              }

              this.categories = data;

              this._updateAllStars();
            }
          );
      }
    });
  }

  _updateAllStars() {
    const categorySlugStar = {};
    this.categories.forEach(x => categorySlugStar[x] = true);

    this.element.querySelectorAll(`i.fa-star`).forEach(star => {
      const categorySlug = star.getAttribute("data-category-slug");

      if (!categorySlug) return;

      const enabled = !!categorySlugStar[categorySlug];

      star.classList.toggle("far", !enabled);
      star.classList.toggle("fas", enabled);
      star.classList.toggle("tw-text-yellow-500", enabled);
    });
  }

  favorite(e) {
    const categorySlug = e.currentTarget.getAttribute("data-category-slug");

    if (this.loggedIn) {
      if (this.categories.includes(categorySlug)) {
        this._unfollowCategory(categorySlug);
      } else {
        this._followCategory(categorySlug);
      }
    } else {
      Cookies.set("categorySlug", categorySlug);
      Cookies.set("followingCategoryRedirect", window.location.href);
    }

    this._trackSelectFollowCategoryCTAEvent(e)
  }

  _unfollowCategory(categorySlug) {
    unfollowCategory(() => {
      this.categories = this.categories.filter(x => x !== categorySlug);
      this._updateAllStars();

      // if refreshing page, don't need to show toast or refresh card
      if (this.refreshValue) {
        window.location.reload();
      } else {
        this._refreshFollowingCategoriesCard();
      }
    }, categorySlug);
  }

  _followCategory(categorySlug) {
    followCategory(() => {
      this.categories.push(categorySlug);
      this._updateAllStars();
      this._refreshFollowingCategoriesCard();
    }, categorySlug);
  }

  _refreshFollowingCategoriesCard() {
    fetch(`/${I18n.locale}/following_categories/top_3_following`)
      .then(async response => {
          if (!response.ok) {
            throw new Error(`Could not retrieve following categories. Error ${response.status}.`);
          }

          const html = await response.text();
          if (!html) {
            throw new Error(`Could not retrieve following categories. Invalid data returned.`);
          }

          const followingCategoriesCard = document.getElementById("following-categories-card");
          followingCategoriesCard.innerHTML = html;
        }
      );
  }

  _trackSelectFollowCategoryCTAEvent(e) {
    const currentPath = window.location.pathname;
    let origin = "category_index";

    if (currentPath.includes("categories/following")) {
      origin = "category_following"
    }

    unconditionalTrackEvent(
      SELECT_FOLLOW_CATEGORY_CTA_EVENT,
      { "origin": origin, "category_name": e?.currentTarget?.dataset?.categoryId }
    );
  }

}
